import { Brain, Sparkles } from "lucide-react";

const BUCKET_COLOR = {
  "0": "text-slate-300",
  "1-3": "text-sky-300",
  "4-6": "text-amber-300",
  "7+": "text-purple-300",
};

export default function ClaudeAIPredictionCard({ forecast, loading, onFetch, upcomingOver }) {
  return (
    <div className="tile p-6 grain relative overflow-hidden" data-testid="claude-ai-forecast-card">
      <div className="absolute -top-12 -right-12 w-64 h-64 rounded-full bg-cyan-500/10 blur-3xl" />
      <div className="relative">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-cyan-500/20 border border-cyan-500/40 flex items-center justify-center">
              <Brain className="w-4 h-4 text-cyan-300" />
            </div>
            <div>
              <div className="font-display font-black uppercase text-lg tracking-tight">Oracle AI Forecast</div>
              <div className="section-label">Claude Sonnet 4.6 · Over #{upcomingOver}</div>
            </div>
          </div>
          <button onClick={onFetch} disabled={loading} className="btn-ghost text-xs" data-testid="ai-forecast-fetch-button">
            <Sparkles className="w-3.5 h-3.5 inline mr-1" />{loading ? "Analyzing…" : forecast ? "Refresh" : "Generate"}
          </button>
        </div>

        {!forecast && !loading && (
          <div className="text-sm text-slate-400 py-6 text-center border border-dashed border-white/10 rounded-lg">
            Ask the Oracle to analyse the match state and predict the upcoming over.
          </div>
        )}

        {loading && (
          <div className="text-sm text-cyan-300 py-6 text-center animate-pulse">Consulting Oracle strategy engine…</div>
        )}

        {forecast && !loading && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Metric label="Expected runs" value={forecast.expected_runs} tone="emerald" />
            <Metric label="Runs bucket" value={forecast.runs_bucket} tone={BUCKET_COLOR[forecast.runs_bucket] || "text-white"} isText />
            <Metric label="Wicket prob" value={`${Math.round(forecast.wicket_probability * 100)}%`} tone="rose" />
            <Metric label="Confidence" value={`${forecast.confidence}%`} tone="amber" />
            <div className="col-span-2 md:col-span-4 mt-2">
              <div className="section-label mb-1">Reasoning</div>
              <div className="text-slate-200 text-sm italic border-l-2 border-cyan-500/50 pl-3">"{forecast.reasoning}"</div>
              <div className="mt-3 flex gap-3 text-xs text-slate-400">
                <span>Bowler threat: <span className="font-mono-data text-white">{forecast.bowler_threat_index}/100</span></span>
                <span>Wicket call: <span className="font-mono-data text-white">{forecast.wicket_prediction ? "Yes" : "No"}</span></span>
                <span className="text-slate-500 ml-auto">{forecast.source}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function Metric({ label, value, tone, isText }) {
  const toneClasses = {
    emerald: "text-emerald-400",
    rose: "text-rose-400",
    amber: "text-amber-400",
  };
  const textCls = isText ? tone : (toneClasses[tone] || "text-white");
  return (
    <div className="tile-elev p-4">
      <div className="section-label">{label}</div>
      <div className={`metric-value text-2xl mt-1 ${textCls}`}>{value}</div>
    </div>
  );
}
